import {Box, Link, Typography} from '@mui/material';
import React from 'react';
import './FooterPanel.scss';
import {t} from 'i18next';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {setDocListBackNavigation} from '../../../../redux/slice/docListSlice';

const FooterPanel = ({panelId}: {panelId: string}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigateToDocList = () => {
    const backPath = `${window.location.pathname}${window.location.search}`;
    dispatch(
      setDocListBackNavigation({
        label: t('docView.title'),
        path: backPath,
      })
    );
    navigate('/Document/DocList');
  };

  return (
    <Box className="doc-view-doc-list-footer">
      <Link
        height="100%"
        href=""
        underline="none"
        data-testid="mini-doc-list-footer"
        data-tab-group={panelId}
        data-tab-id="doc-list-footer-button"
        onClick={navigateToDocList}
      >
        <Typography
          className="footer-text typo-text buttonXS_size"
          data-testid={`footer-panel-view-all-in-doc-list`}
        >
          {t('docView.docList.viewAllInDocList')}
        </Typography>
      </Link>
    </Box>
  );
};

export default FooterPanel;
